import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { loadPosts } from '../../../../redux/modules/posts';
import connectDataFetchers from '../../../shared/lib/connectDataFetchers.js';

import ListSinglePost from './ListSinglePost';
import Pager from '../../../shared/Pager/Pager';

import './PostList.scss';
import { cleanImage } from '../../../../utils/images.js';

class PostList extends Component {
  renderPosts = (posts, uiVariantButton) => {
    return posts.map(post => {
      return (
        <div className="col-md-6 col-lg-4" key={post.id}>
          <ListSinglePost post={post} uiVariantButton={uiVariantButton} />
        </div>
      );
    });
  };

  render() {
    const {
      posts,
      pagination,
      location,
      siteName,
      logoImage,
      primaryColor,
      uiVariantButton,
    } = this.props;

    return (
      <div className="post-list">
        <Helmet
          title={`Blog`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia - Blog`,
            },
            { name: 'keywords', content: `${siteName}, blog farmacia` },
            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia - Blog`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia - Blog`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />

        <div className="container">
          {!!posts.length ? (
            <div>
              <h1>Magazine</h1>

              <div className="row">
                {this.renderPosts(posts, uiVariantButton)}
              </div>

              <Pager
                location={location}
                page={location.query.page || 1}
                totalPages={pagination.totalPages}
                primaryColor={primaryColor}
                isNew
                uiVariantButton={uiVariantButton}
              />
            </div>
          ) : (
            <div>
              <p>Non è presente nessun articolo.</p>
              <p>Torna a trovarci presto!</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    posts: state.posts.data.posts,
    pagination: state.posts.pagination,
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(PostList, [loadPosts])
);
